<div class="card mb-0 booking-search-container" [ngClass]="classes" [class.is-collapsed]="!isHomeRoute && !showFullForm">
  @if (showHeader) {
  <div class="card-header d-flex align-items-center justify-content-between" [hidden]="!isHomeRoute && !showFullForm">
  <ul class="nav mb-0 booking-tabs-unified">
    <li>
      <a href="javascript:void(0);" (click)="setSearchType(searchTypeEnum.FLIGHT)"
         class="nav-link"
         [ngClass]="{'active': searchType === searchTypeEnum.FLIGHT}"
         data-bs-toggle="tab" data-bs-target="#flight">
        <div class="tab-icon-text">
          <i class="isax isax-airplane5"></i>
          <span>Flights</span>
        </div>
      </a>
    </li>
    <li>
      <a href="javascript:void(0);" (click)="setSearchType(searchTypeEnum.HOTEL)"
         class="nav-link"
         [ngClass]="{'active': searchType === searchTypeEnum.HOTEL}"
         data-bs-toggle="tab" data-bs-target="#Hotels">
        <div class="tab-icon-text">
          <i class="isax isax-buildings5"></i>
          <span>Hotels</span>
        </div>
      </a>
    </li>
    <li>
      <a href="javascript:void(0);" (click)="setSearchType(searchTypeEnum.CAR)"
         class="nav-link"
         [ngClass]="{'active': searchType === searchTypeEnum.CAR}"
         data-bs-toggle="tab" data-bs-target="#Cars">
        <div class="tab-icon-text">
          <i class="isax isax-car5"></i>
          <span>Cars</span>
        </div>
      </a>
    </li>
  </ul>
</div>
  }

  <!-- Compact summary (non-home only) -->
  <button *ngIf="!isHomeRoute && !showFullForm" type="button" class="compact-summary" (click)="toggleFormVisibility()" [attr.aria-label]="summaryTitle + ' ' + summarySubtitle">
    <span class="summary-icon"><i class="isax isax-search-normal-1" aria-hidden="true"></i></span>
    <span class="summary-text">
      <span class="title fw-medium">{{ summaryTitle }}</span>
      <span class="sub text-muted">{{ summarySubtitle }}</span>
    </span>
  </button>

  <div class="card-body" [hidden]="!isHomeRoute && !showFullForm">
    <div>
      <div class="tab-content">

        <div class="tab-pane fade" id="flight" [ngClass]="{'show active': searchType === searchTypeEnum.FLIGHT}">
          <app-flight-search (search)="search($event)"></app-flight-search>
        </div>


        <div class="tab-pane fade" id="Hotels" [ngClass]="{'show active': searchType === searchTypeEnum.HOTEL}">
            <app-hotel-search (search)="search($event)"></app-hotel-search>
        </div>

        <div class="tab-pane fade" id="Cars" [ngClass]="{'show active': searchType === searchTypeEnum.CAR}">
            <app-car-search (search)="search($event)"></app-car-search>
        </div>

      </div>
      <div class="d-flex justify-content-end mt-2 d-sm-none" *ngIf="!isHomeRoute">
        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="toggleFormVisibility()">Hide</button>
      </div>
    </div>
  </div>

</div>
